@use '@design/design-tokens/typography/typography' as *;

.chartEmptyRoot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 300px;
  margin: 0 auto;
  padding: 12px;
}

.imageWrapper {
  margin-bottom: 12px;
}

.title {
  @include typography-v2-title-base;
  color: var(--text-default);
}

.description {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  margin-bottom: 16px;
}
